import React from 'react'

const MaterialRecieptNoteMaster = () => {
  return (
    <div>MaterialRecieptNoteMaster</div>
  )
}

export default MaterialRecieptNoteMaster